package de.oevbs.kunde.kundenportal2.navigation

import dev.fritz2.core.Handler
import dev.fritz2.routing.MapRouter
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

/**
 * [MapRouter]-Subklasse, die zusätzlich zur Unterstützung von URL-Parametern als Map Kundenportal-spezifische
 * Funktionen und Properties bereitstellt.
 */
class KupoRouter(defaultRoute: String) : MapRouter(mapOf(PAGE_ROUTE_KEY to defaultRoute), Job()) {

    companion object {
        const val PAGE_ROUTE_KEY: String = "page"
    }

    val navToPageRoute: Handler<String> = handle { _, route ->
        mapOf(PAGE_ROUTE_KEY to route)
    }

    val navToRouteWithParams: Handler<Pair<String, Map<String, String>>> = handle { _, (route, params) ->
        mapOf(PAGE_ROUTE_KEY to route) + params
    }

    val route: Flow<String?> =
        select(PAGE_ROUTE_KEY).map { (route, _) -> route }
}